import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined'
import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import PhoneCard from '../../../components/card/AddressCards/phoneCard'
import CustomisedCardLine from '../../../components/card/cardLine'
import MailBox from '../../../components/icons/MailBox'
import ElementTitle from '../../../components/title/elementTitle/elementTitle'
import { IGetSupportInfoResponse } from '../../../models/basicInformation.model'
import { changeRouteType, getpervInnerState } from '../../../redux/handleBackBtn/handleBackBtnSlice'
import { setHeaderTitle } from '../../../redux/headerTitle/headerTitleSlice'
import { GetSupportInfo } from '../../../services/basicInformation.service'
import SupportSkeleton from './supportSkeleton'


const Support = () => {

    const [supportData, setSupportData] = useState<IGetSupportInfoResponse[]>()
    const [telephone, setTelephone] = useState<{ title: string; value: string | React.ReactElement }[]>([])
    const [workingDays, setWorkingDays] = useState<{ title: string; value: string }[]>([])
    const dispatch = useDispatch()
    const randomKeyForDispatch = Math.random();
    const { mutate: GetSupportInfoMutate, isLoading } = useMutation(GetSupportInfo, {
        onSuccess: (data: IGetSupportInfoResponse[]) => {
            if (data) {
                setSupportData(data)
                const telephone: { title: string; value: string | React.ReactElement }[] = data[0].phoneNumbers.map((item) => {
                    return {
                        title: item, value: <a className='text-[var(--primaty-text-color)]' href={`tel:${item}`} style={{ textDecoration: 'none' }}>
                            <LocalPhoneOutlinedIcon sx={{ color: "var(--tirnary-text-color)" }} />
                        </a>
                    }
                })
                setTelephone(telephone)

                const workingDays: { title: string; value: string }[] = data[0].workSchedules.map((day) => {
                    return {
                        title: day.workingDays,
                        value: day.workingHours
                    }
                })
                setWorkingDays(workingDays)
            }
        },
        onError: () => { },
    });





    useEffect(() => {
        GetSupportInfoMutate()
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `profile ${randomKeyForDispatch}` }));
        dispatch(setHeaderTitle({ header: 'پشتیبانی', color: 'var(--header-color)', parentRoute: '', }));
    }, [])



    if (isLoading) return <SupportSkeleton />
    return (
        <>
            {supportData && <div className='h-[calc(100svh-120px)] overflow-y-auto'>

                <Box sx={{ paddingInline: "20px", marginTop: "20px", display: "flex", flexDirection: "column", gap: "7px" }}>
                    <ElementTitle title='تلفن های تماس' />
                    <PhoneCard cardContent={telephone} />
                </Box>
                <Box sx={{ paddingInline: "20px", marginTop: "20px", display: "flex", flexDirection: "column", gap: "7px" }}>
                    <ElementTitle title='ساعات کاری' />
                    <CustomisedCardLine itemList={workingDays} />
                </Box>
                <Box sx={{ marginBottom: "20px", paddingInline: "20px", marginTop: "20px", display: "flex", flexDirection: "column", gap: "7px" }}>
                    <ElementTitle title='نشانی' />
                    <CustomisedCardLine itemList={[{
                        title: <><MailBox sx={{ marginLeft: "5px", fontSize: "20px", marginBottom: "5px" }} />کد پستی</>
                        , value: supportData![0]?.postalCode
                    }, { title: supportData![0]?.address }]} />
                </Box>
            </div>}
        </>
    )
}

export default Support
